import React from "react";
import {
    faArrowsRotate,
    faCheckCircle,
    faGears,
    faRulerCombined,
    faShieldHalved,
    faWeightHanging,
} from "@fortawesome/free-solid-svg-icons";
import ProductTypes from "../../components/ProductTypes";

const AutomatedMachinery = () => {
    const products = [
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165608/HexBolts_pgfidx.webp", name: "Hex Bolts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165607/HeavyHexBolts_xx6h1o.webp", name: "Heavy Hex Bolts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165600/FlangeBolts_takwzg.webp", name: "Flange Bolts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070889/Pneumatic_Rivet_Gun_ao3cec.webp", name: "Pneumatic Rivet Gun" },
    ];

    const bannerImage = "https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/AutomatedMachinery_oifnzk.webp";
    const heading = "Automated Machinery";
    const description =
        "Our Automated Machinery fasteners are engineered to withstand the rigorous demands of industrial automation and precision equipment. Designed for mission-critical applications, they deliver exceptional strength, durability, and accuracy—ensuring seamless operations and extending equipment life.";

    const benefits = [
        { icon: faWeightHanging, text: "Withstands demanding heavy-duty machinery applications" },
        { icon: faRulerCombined, text: "Supports reliable assembly in automation systems" },
        { icon: faArrowsRotate, text: "Maintains stability during continuous, high-speed operations" },
        { icon: faShieldHalved, text: "Built for extended service life in harsh operating conditions" },
        { icon: faGears, text: "Compatible with automated assembly processes" },
        { icon: faCheckCircle, text: "Designed for mission-critical applications" },
    ];

    return (
        <ProductTypes
            products={products}
            image={bannerImage}
            heading={heading}
            description={description}
            benefits={benefits}
        />
    );
};

export default AutomatedMachinery;
